import { useState, useEffect, useRef } from 'react'
import { motion } from 'framer-motion'
import ourservices1 from '../../Assets/Home/ourservices1.svg'
import ourservices2 from '../../Assets/Home/ourservices2.svg'
import ourservices3 from '../../Assets/Home/ourservices3.svg'
import ourservices4 from '../../Assets/Home/ourservices4.svg'
import ourservices5 from '../../Assets/Home/ourservices5.svg'

const AUTO_ADVANCE_SECONDS = 3;

const OurServices = () => {
    const [toggleState, setToggleState] = useState(1);
    const [isPaused, setIsPaused] = useState(false);
    const scrollerRef = useRef(null);
    const servicesicons = [ourservices1, ourservices2, ourservices3, ourservices4, ourservices5];

    const designdata = ["Pre Engineering", "Feasibility", "Preliminary Project Report", "Detail Design", "Detail Design Report (DPR)"];
    const supervisiondata = ["Project Management", "Authority Engineer", "Operations & Maintenance", "Independent Engineering", "Proof Check, Safety", "Quality control and Audit"];

    const designDescriptions = [
        "We provide pre-engineering consulting for your projects.",
        "We analyze the feasibility of your project in terms of cost, time, and resources.",
        "Our team helps prepare the preliminary project report to outline project scope.",
        "We offer detailed design services to ensure project success.",
        "The Detailed Project Report (DPR) helps in planning and execution."
    ];

    const supervisionDescriptions = [
        "We oversee project management to ensure timely and successful delivery.",
        "Our engineers work as the authority for your projects to ensure quality and compliance.",
        "We manage operations and maintenance post-project to ensure longevity and performance.",
        "Independent engineering services to review project design and specifications.",
        "We provide proof-checking for designs, ensuring safety and compliance.",
        "We conduct quality control and audits throughout the project lifecycle."
    ];

    const designServices = designdata.map((name, index) => ({
        name,
        img: servicesicons[index % servicesicons.length],
        description: designDescriptions[index % designDescriptions.length]
    }));

    const supervisionServices = supervisiondata.map((name, index) => ({
        name,
        img: servicesicons[index % servicesicons.length],
        description: supervisionDescriptions[index % supervisionDescriptions.length]
    }));

    const activeData = toggleState === 1 ? designServices : supervisionServices;

    useEffect(() => {
        if (scrollerRef.current) scrollerRef.current.scrollLeft = 0;
    }, [toggleState]);

    useEffect(() => {
        if (isPaused) return;
        const el = scrollerRef.current;
        if (!el) return;

        const timer = setInterval(() => {
            if (!el) return;
            const cardWidth = el.firstChild ? el.firstChild.offsetWidth + 20 : 260;
            const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 10;
            el.scrollTo({
                left: atEnd ? 0 : el.scrollLeft + cardWidth,
                behavior: 'smooth',
            });
        }, AUTO_ADVANCE_SECONDS * 1000);

        return () => clearInterval(timer);
    }, [isPaused, toggleState]);

    return (
        <div id='our-services' className='relative text-center mt-16 mb-20'>
            <p className='relative text-stone-800 md:text-4xl text-4xl mb-16 font-semibold service-div'>
                Our<span className='purple'> Services</span>
            </p>

            <div className='relative z-10 flex flex-col items-center justify-center mx-auto gap-0 bg-gradient-to-r from-[#61acca] to-[#8364c3] py-14 md:py-16'>

                <div className="relative flex bg-white/15 rounded-full p-1 mb-10">
                    <motion.div
                        className="absolute top-1 bottom-1 w-1/2 bg-white rounded-full shadow-md"
                        animate={{ left: toggleState === 1 ? '4px' : '50%' }}
                        transition={{ type: 'spring', stiffness: 300, damping: 26 }}
                    />
                    <button
                        className={`relative z-10 px-6 md:px-10 py-2 rounded-full font-medium transition-colors duration-300 ${toggleState === 1 ? 'text-[#61acca]' : 'text-white'}`}
                        onClick={() => setToggleState(1)}
                    >
                        Design
                    </button>
                    <button
                        className={`relative z-10 px-6 md:px-10 py-2 rounded-full font-medium transition-colors duration-300 ${toggleState === 2 ? 'text-[#8364c3]' : 'text-white'}`}
                        onClick={() => setToggleState(2)}
                    >
                        Supervision
                    </button>
                </div>

                <div
                    ref={scrollerRef}
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                    className="w-full max-w-6xl flex gap-5 overflow-x-auto px-6 md:px-10 pb-2 snap-x snap-mandatory scroll-smooth [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
                >
                    {activeData.map((item, i) => (
    <div
        key={toggleState + '-' + item.name}
        className="relative shrink-0 snap-start w-[200px] sm:w-[250px] min-h-[250px] sm:min-h-[270px] bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-5 flex flex-col justify-end overflow-hidden"
    >
        <span className="absolute top-1 right-3 text-white/15 font-extrabold leading-none select-none text-[4.5rem]">
            {String(i + 1).padStart(2, '0')}
        </span>
        <div className="relative z-10 flex flex-col items-start text-left gap-2">
            <img src={item.img} alt={item.name} className="w-7 h-7 object-contain" />
            <p className="text-white text-base font-semibold leading-snug min-h-[44px] flex items-end">{item.name}</p>
            <p className="text-white/80 text-xs leading-relaxed">{item.description}</p>
        </div>
    </div>
))}
                </div>
            </div>
        </div>
    )
}

export default OurServices